// extracted by mini-css-extract-plugin
module.exports = {"DivinationForm__Search":"LiarO","DivinationForm__Input":"bZirH","DivinationForm__Button":"Z8OGl","DivinationForm__Button_disabled":"JAIzt","DivinationForm__ButtonIcon":"X3BTj"};